import { generatePath } from 'react-router-dom';

import * as ROUTES from '#client/constants/routes';

import { processMenu } from '../utils/menu';

/**
 * Get the my business menu items.
 *
 * @param {{
 *  businessEntityUuid: string
 *  entitlements: Set<string>
 * }} params
 * @returns {Array}
 */
export function getMyBusinessMenuItems({ businessEntityUuid }) {
  return [
    {
      order: 10,
      title: 'Business Profile',
      itemId: 'mybusiness_profile',
      path: generatePath(ROUTES.entityProfile, { businessEntityUuid }),
    },
    {
      order: 20,
      title: 'Order History',
      itemId: 'mybusiness_order_history',
      path: generatePath(ROUTES.entityOrders, { businessEntityUuid }),
    },
  ];
}

/**
 * Get the my business menu.
 *
 * @param {{
 *  businessEntityUuid: string
 *  order?: number
 * }} params
 * @returns {object}
 */
export function getMyBusinessMenu({ businessEntityUuid, order }) {
  return processMenu({
    title: 'My Business',
    itemId: 'mybusiness',
    icon: 'briefcase-one-fill.svg',
    links: getMyBusinessMenuItems({ businessEntityUuid }),
    order,
  });
}
